export const START_FETCH = "START_FETCH";
export const FETCH_SUCCESS = "FETCH_SUCCESS";
export const ERROR_CATCHED = "ERROR_CATCHED";
export const INPUT_EDIT = "INPUT_EDIT";
export const INPUT_EDIT_LOG = "INPUT_EDIT_LOG";
export const INPUT_EDIT_REG = "INPUT_EDIT_REG";
export const TOGGLE_MODE = "TOGGLE_MODE";//ログインとレジスターを切り替えるコマンド